import React from "react";

const Java_New = () => {
  return (
    <div>
      <h1>Java New</h1>
      <p>This page provides explanations, examples, and common use-cases for Java New in Java.</p>
    </div>
  );
};

export default Java_New;
